import * as React from 'react';
import { IHeiStoreAddressViewProps } from './hei-store-address';
import classnames from 'classnames';

export default (props: IHeiStoreAddressViewProps) => {
    const {
        store,
        config: { className }
    } = props;

    return (
        <div className={classnames('hei-store-address', className)}>
            <p className='addr-lines'>{store.Address}</p>
        </div>
    );
};
